<template xmlns="http://www.w3.org/1999/html">
    <fragment>
        <b-modal v-model="modalVisible" size="sm">
            <template v-slot:modal-header="{ close }">
                <div class="row" style="width: 100%">
                    <div class="col-md-10 offset-md-1 text-center d-flex justify-content-center">
                        <h3> {{ __('connect_with') }} </h3>
                        <button-open-help-modal :helpName="helpName" :inExtraDiv="false" :color="'black'"/>
                    </div>
                    <div class="col-md-1">
                        <button type="button" class="close" v-on:click="restoreModal">
                            <span aria-hidden="true">&times;</span>
                            <span class="sr-only">{{ __('close') }}</span>
                        </button>
                    </div>
                </div>
            </template>

            <template v-slot:default="{}">

                <div class="row" id="modalContentCashRegister">

                    <div class="col-md-12">
                        <label v-if="showDocumentFields()"><strong>{{ __('document_number') }}</strong></label>
                        <input v-if="showDocumentFields()" type="text" class="form-control m-b-xs" disabled=""
                               v-model="documentNumber">

                        <div class="panel panel-warning m-b-xs" v-if="showDocumentFields() && documentIsLocked()">
                            <div class="panel-heading">
                                <i class="fas fa-exclamation-triangle white" style="color:#fff"></i> {{ __('warning') }}
                            </div>
                            <div class="panel-body">
                                <p class="m-b-none">{{ document.update_blocked_message }}</p>
                            </div>
                        </div>

                        <div class="panel panel-warning m-b-xs"
                             v-if="showDocumentFields() && documentIsAcceptedInAnotherDepartment()">
                            <div class="panel-heading">
                                <i class="fas fa-exclamation-triangle" style="color:#fff"></i> {{ __('warning') }}
                            </div>
                            <div class="panel-body">
                                <p class="m-b-none">{{ __('document_was_adopted_by_another_department_cash_register_alert') }}</p>
                            </div>
                        </div>
                        <div class="panel panel-warning m-b-xs"
                             v-if="showDocumentFields() && documentIsTransferedAndNotAccepted()">
                            <div class="panel-heading">
                                <i class="fas fa-exclamation-triangle" style="color:#fff"></i> {{ __('warning') }}
                            </div>
                            <div class="panel-body">
                                <p class="m-b-none">{{ __('document_was_transfer_and_not_accepted') }}</p>
                            </div>
                        </div>

                        <label class="m-b-xs" v-if="(hasAccessDefault == 1 && !showDocumentMode) || (showDocumentMode && hasAccessOtherDepartment == 1)"><input v-if="(hasAccessDefault == 1 && !showDocumentMode) || (showDocumentMode && hasAccessOtherDepartment == 1)" :disabled="isDisabled('cash_register_receipt')" type="radio"
                                                     v-model="connection_type" checked
                                                     value="cash_register_receipt">
                            <strong>{{ __('cash_register_receipt') }}</strong></label><br>
                        <label class="m-b-xs" v-if="(hasAccessDefault == 1 && !showDocumentMode) || (showDocumentMode && hasAccessOtherDepartment == 1)"><input v-if="(hasAccessDefault == 1 && !showDocumentMode) || (showDocumentMode && hasAccessOtherDepartment == 1)" :disabled="isDisabled('own_invoice')" type="radio"
                                                     v-model="connection_type"
                                                     value="own_invoice">
                            <strong>{{ __('own_invoice_for_register') }}</strong></label><br>
                        <label v-if="(hasAccessPl === 1 &&  !showDocumentMode) || (showDocumentMode && hasAccessOtherDepartment == 1)" class="m-b-xs" ><input v-show="(hasAccessPl === 1 &&  !showDocumentMode) || (showDocumentMode && hasAccessOtherDepartment == 1)"
                                                                              :disabled="isDisabled('own_invoice_pl')"
                                                                              type="radio"
                                                                              v-model="connection_type"
                                                                              value="own_invoice_pl">
                            <strong v-show="(hasAccessPl === 1 &&  !showDocumentMode) || (showDocumentMode && hasAccessOtherDepartment == 1)">{{
                                    __('own_invoice_pl_for_register')
                                }}</strong></label><br v-show="hasAccessPl === 1">
                        <label v-if="(hasAccessPl === 1 &&  !showDocumentMode) || (showDocumentMode && hasAccessOtherDepartment == 1)" class="m-b-xs" ><input v-show="(hasAccessPl === 1 &&  !showDocumentMode) || (showDocumentMode && hasAccessOtherDepartment == 1)"
                                                                              :disabled="isDisabled('invoice_margin_pl')"
                                                                              type="radio"
                                                                              v-model="connection_type"
                                                                              value="invoice_margin_pl">
                            <strong v-show="(hasAccessPl === 1 &&  !showDocumentMode) || (showDocumentMode && hasAccessOtherDepartment == 1)">{{ __('add_own_bill_pl_margin_invoice') }}</strong></label><br v-show="(hasAccessPl === 1 &&  !showDocumentMode) || (showDocumentMode && hasAccessOtherDepartment == 1)">


                        <input type="checkbox" v-model="documentTransfer" v-if="departments.length >= 1"
                               :disabled="connection_type === 'source_transfer' || showDocumentFields() && (documentIsLocked() || documentIsAcceptedInAnotherDepartment() || documentIsTransferedAndNotAccepted())|| actionType==='show' || actionType==='showGroup'"
                               :readonly="showDocumentFields() && (documentIsLocked() || documentIsAcceptedInAnotherDepartment() || documentIsTransferedAndNotAccepted())"/>
                        <label v-if="departments.length >= 1">{{ __('transfer_document_to_department') }}</label>
                        <div class="row"
                             v-if="documentTransfer && departments.length >= 1 && connection_type !== 'source_transfer'">
                            <div class=" col-md-12 m-b-sm">
                                <select2
                                    :readonly="showDocumentFields() && (documentIsLocked() || documentIsAcceptedInAnotherDepartment() || documentIsTransferedAndNotAccepted())"
                                    :dropdownParent="select2DropdownParent"
                                    :settings="{ width:'300px'}"
                                    :options="departmentsOptions"
                                    :value="documentTransferToDepartment"
                                    v-model="documentTransferToDepartment">
                                </select2>
                            </div>
                        </div>
                        <label class="m-b-xs">
                            <input type="radio" value="source_transfer" v-model="connection_type" name="optionsRadios"
                                   :disabled="isDisabled('source_transfer')" @click="uncheckDocumentTransfer()">
                            <strong>{{ __('transfer_between_sources') }}</strong></label><br>
                        <div class="row" v-if="connection_type === 'source_transfer'">
                            <div class=" col-md-12 m-b-sm"
                                 :class="{'has-error' : formErrors !== undefined && formErrors.hasOwnProperty('amount')}">
                                <input
                                    class="form-control text-right split split-amount money"
                                    type="text"
                                    placeholder=""
                                    :disabled="actionType ==='show' || method === 'show' ||  group.status == 'closed'"
                                    v-model="source_transfer_amount"
                                    @change="handleSourceTransferAmountChange()"
                                >
                                <span class="help-block text-danger"
                                      v-if="formErrors !== undefined && formErrors.hasOwnProperty('amount')">{{ formErrors['amount'].length > 0 ? formErrors['amount'][0] : '' }}</span>
                            </div>
                        </div>
                    </div>
                </div>

            </template>
            <template v-slot:modal-footer="{}">
                <div class="row m-b">
                    <div class="col-md-12 text-right">
                        <button
                            v-if="createInvoiceForBillVisible"
                        style="margin-right: 100px"
                        type="button"
                        class="btn btn-primary"
                        :disabled="(actionType ==='show' || method === 'show') && source_transfer"
                        @click="openModalChooseOptionsForBill()"
                    >
                        {{ __('create_invoice_for_bill') }}
                    </button>
                        <button type="button" class="btn btn-white cancel-and-refresh" v-on:click="restoreModal">
                            {{ __('cancel') }}
                        </button>
                        <button
                            v-if="group.status != 'closed' && (!showDocumentMode && (hasAccessDefault == 1 || hasAccessPl == 1)) || (showDocumentMode && hasAccessOtherDepartment == 1)"
                            type="submit"
                            class="btn btn-primary m-r save-connect-with"
                            :disabled="(actionType==='show' || method === 'show') && source_transfer"
                            @click="save"
                        >
                            <span>
                                {{ __('ok') }}
                            </span>
                        </button>
                    </div>
                </div>
            </template>
        </b-modal>
    </fragment>
</template>

<script>
import mutations from "../../vuex/payments/mutation_types";

import {Money} from "../../services/Money";
import actions from "../../vuex/action_types";
import {Fragment} from 'vue-fragment';


export default {
    name: "OperationConnectWithInCashRegisterModal",
    components: {Fragment},
    data: function () {
        return {
            modalVisible: false,
            modalSize: 'sm',
            dynamicContent: [],
            documentNumber: null,
            documentTransfer: false,
            source_transfer: false,
            documentTransferToDepartment: null,
            source_transfer_amount: null,
            money: new Money(),
            connection_type: 'cash_register_receipt',
            formErrors: {},
            document_id: null,
            document: {},
            stateToCommit: {
                documentAllocations: [],
                departments: [],
                categories: [],
                contractorTransfers: [],
                contractorTransfersDocuments: [],
                transferBetweenSources: [],
                documentsPayments: [],
                paymentCorrections: [],
                paymentCorrectionsOffsets: [],
                currencyExchanges: [],
                currencyExchangesOffsets: [],
                correctionsForDelete: [],
                correctionsOffsetsForDelete: [],
                currencyExchangesForDelete: [],
                currencyExchangesOffsetForDelete: [],
                transferDocumentsForDelete: [],
                generatedBalanceForDelete: [],
                newDocumentForOperation : [],
            },
        }
    },
    props: {
        helpName: {
            type: String,
            default: null
        },
        operationIndex: {
            required: true,
        },
        actionType: {
            type: String,
            required: true,
        },
        operation: {
            type: Object,
            required: true,
        },
        departments: {
            type: Array,
            required: false,
        },
        group: {
            type: Object,
            required: false,
        },
        paymentSource: {
            type: Object,
            required: false,
        },
        method: {
            type: String,
            required: true,
        },
        hasAccess: {
            type: Number,
            required: false,
            default: 0,
        },
        hasAccessDefault: {
            type: Number,
            required: false,
            default: 0,
        },
        hasAccessPl: {
            type: Number,
            required: false,
            default: 0,
        },
        hasAccessOtherDepartment: {
            type: Number,
            required: false,
            default: 0,
        },
        allowInvoiceForBillWithoutContractor: {
            type: Number,
            required: false,
            default: 0,
        },
    },

    computed: {
        createInvoiceForBillVisible: function (){
            let allow_invoice_for_bill_without_contractor = true;
            if(this.allowInvoiceForBillWithoutContractor == 0){
                allow_invoice_for_bill_without_contractor = this.document.contractor_id != null;
            }
            return this.document.document_id > 0 && this.actionType !== 'show' &&  this.method !== 'show' && !this.documentIsLocked() && !this.documentIsAcceptedInAnotherDepartment() &&
                this.document.can_be_bill_for_invoice == 1 && allow_invoice_for_bill_without_contractor;
        },
        helpLocalizationName: function () {
            return this.$props.helpName;
        },
        modalContext: function () {
            // this.$store.getters.getModalContext
            this.$store.commit(mutations.INIT_MODAL_CONTENT, {
                'content': this.dynamicContent
            });
            return this.dynamicContent;
        },
        departmentsOptions: function () {
            // operationContractorTransfers[contractorTransferIndex].contractor_id4
            let options = this.departments.map((option) => {
                return {
                    text: option.name,
                    id: option.id
                }
            })
            // options.unshift({text: '---', id: -1})
            return options;
        },
        select2DropdownParent: function () {
            return $('#modalContentCashRegister');
        },
        showDocumentMode:function (){
            return this.showDocumentFields() && (this.documentIsLocked() || this.documentIsAcceptedInAnotherDepartment() || this.documentIsTransferedAndNotAccepted()||this.actionType === 'show' || this.actionType === 'showGroup')
        }
    },
    methods: {
        openModalChooseOptionsForBill:function (){
            let documentId = this.document.document_id;
            $('#document_id').val(documentId)
            $('#group_id_choose_options_for_invoice_for_bill').val(this.group.id)
            $('#payment_source_choose_options_for_invoice_for_bill').val(this.paymentSource.id)
            $('#payment_source_id_modal').val(this.paymentSource.id)
            $('#source_type_modal').val('cash_register')
            $('#operation_department_id-modal').val(this.documentTransfer ? this.documentTransferToDepartment : this.paymentSource.department_id)
            doAjax('/records/documents/get-options-for-invoice-bill', {'id':documentId}, 'GET').then((response)=>{

                loadDocumentTypesOptions(response)
                $('#available_contractors_id_types').val(response.contractors_id_number)
                $('#available_contractors_id_numbers').val(response.contractors_number)
                if(response.contractor_visible){
                    $('.contractor-bill-options').show()
                }
                else {
                    $('.contractor-bill-options').hide();
                }
                loadContractorsOptions(response);
                loadContractorsIdNumbersOptions(response)
                $('#document_type').select2({
                    dropdownParent: $('#choose-options-for-invoice-for-bill')
                });
                $('#contractor').select2({
                    dropdownParent: $('#choose-options-for-invoice-for-bill')
                });
                this.restoreModal()
                this.$emit('setStorageData')
                $('#choose-options-for-invoice-for-bill').modal('show');

            })
        },
        restoreModal: function () {
            this.modalVisible = false;
            this.resetData()
        },
        resetData: function () {
            this.documentNumber = null;
            this.documentTransfer = false;
            this.source_transfer = false;
            this.documentTransferToDepartment = null;
            this.source_transfer_amount = null;
            this.connection_type = 'cash_register_receipt';
            this.formErrors = {};
        },
        save: function () {
            const self = this;
            window.localStorage.setItem('operation_date', this.operation.date)
            window.localStorage.setItem('group_hidden_name', this.group.name)
            this.$emit('setStorageData')
            if (this.connection_type !== "source_transfer") {
                let paymentGroup = this.group !== null ? `&group=${this.group.id}` : ""
                const paymentSource = this.paymentSource ? `&payment-source=${this.paymentSource.id}` : "";
                const showModal = `&showModal=false`
                const method = this.operation.id > 0 ? 'edit' : 'create'
                if (method === 'create') {
                    window.location.href =
                        "/records/documents/create/" +
                        this.connection_type +
                        "?return=" +
                        encodeURIComponent(window.location.href) +
                        paymentGroup +
                        paymentSource + this.documentQueryString();
                } else {
                    if (this.showDocumentFields() && (this.documentIsLocked() || this.documentIsAcceptedInAnotherDepartment() || this.documentIsTransferedAndNotAccepted()||this.actionType === 'show' || this.actionType === 'showGroup')) {
                        window.location.href = '/records/documents/' + this.document_id + '/?return=' + encodeURIComponent(window.location.href) + paymentSource
                    } else {
                        window.location.href = '/records/documents/' + this.document_id + '/edit?return=' + encodeURIComponent(window.location.href) + paymentGroup + showModal + paymentSource + this.documentQueryString();
                    }
                }
            } else {

                this.$store.dispatch(actions.STORE_SOURCE_TRANSFER_IN_CASH_REGISTER, {
                    group_id: this.group.id,
                    action_type: 'create',
                    created_operation: self.operation,
                    amount: self.source_transfer_amount,
                    current_url_to_block: $('#current-url-to-lock').val()
                }).then(response => {

                    if (response.data.notification.alert_type !== 'error') {
                        toastr[response.data.notification.alert_type](self.__(response.data.notification.message)).css('border', '0px')

                    }
                    if (self.actionType === 'createGroup' || self.actionType === 'editGroup' || self.actionType === 'create' || self.actionType === 'edit' || self.actionType === 'create?') {
                        this.$emit('reloadOperations',response.data.notification.created_operation, self.operation.id, self.operation.date, response.data.notification.operation_title, response.data.notification.source_transfer_amount, response.data.notification.original_index)
                        self.restoreModal()
                    } else {
                        self.restoreModal()
                        return location.reload();
                    }

                }).catch(error => {
                    console.log('errors: ', error);
                    self.formErrors = error.response.data.errors;
                });
            }

        },
        documentQueryString: function () {
            const amount = this.operation.formatted_amount !== '0,00' ? this.operation.formatted_amount : null;
            const operation_id = this.operation.id;
            const date = this.operation.date
            const contractor_id = (this.operation.contractor_id !== 0 && this.operation.contractor_id !== '0') ? this.operation.contractor_id : null
            const title = this.operation.title
            const description = this.operation.description
            const department_id_transfer = this.documentTransfer ? this.documentTransferToDepartment : this.paymentSource.department_id;
            const method = this.operation.id > 0 ? 'edit_operation' : 'create_operation';
            const payment_source_id = this.paymentSource.id;
            const source_type = 'cash_register'
            return "&operation_amount=" + amount +
                '&operation_id=' + operation_id +
                '&operation_date=' + date +
                '&contractor_id=' + contractor_id +
                '&operation_title=' + title +
                '&operation_description=' + description +
                '&operation_department_id=' + department_id_transfer +
                '&operation_method=' + method +
                '&payment_source_id=' + payment_source_id +
                '&source_type=' + source_type;
        },
        showDocumentFields: function () {
            if (this.document.document_id !== undefined && this.document.document_id !== undefined > 0) {
                return true;
            }
            return false;
        },
        loadModalData: function () {
            this.prepareDocumentAllocations();
            this.prepareSourceTransfer()
        },
        sendToStore: function () {
           return;
        },
        prepareDocumentAllocations: function () {
            if (this.modalContext.documentPayments !== undefined && this.modalContext.documentPayments.length > 0) {
                this.document = this.modalContext.documentPayments[0].target;
            } else if (this.modalContext.contractorTransfers !== undefined && this.modalContext.contractorTransfers.length > 0) {
                this.document = this.modalContext.contractorTransfers[0].target
            }
            else if(this.modalContext.departmentTransfers !== undefined && this.modalContext.departmentTransfers.length > 0){
                this.document = this.modalContext.departmentTransfers[0].target;
            }
            if (this.document.hasOwnProperty('document_id')) {
                this.documentNumber = this.document.document_number;
                this.document_id = this.document.document_id;
                this.connection_type = this.document.document_type

                if (parseInt(this.document.department_id) !== parseInt(this.paymentSource.department_id)) {
                    this.documentTransfer = true;
                    this.documentTransferToDepartment = parseInt(this.document.department_id)
                }
            } else {
                this.connection_type = 'cash_register_receipt'
            }

        },
        prepareSourceTransfer: function () {
            if (this.modalContext.sourceTransfers !== undefined && this.modalContext.sourceTransfers.length > 0) {
                this.connection_type = 'source_transfer';
                this.source_transfer_amount = this.money.localize(this.modalContext.sourceTransfers[0].target_amount);
            }
        },
        documentIsLocked: function () {
            return this.showDocumentFields() && this.document.update_blocked_message !== "";
        },
        documentIsAcceptedInAnotherDepartment: function () {
            return this.showDocumentFields() && (this.operation !== undefined && this.operation.payment_source.department_id !== this.document.department_id) && (this.document.department_not_accepted == 0 || this.document.department_not_accepted == null);
        },
        documentIsTransferedAndNotAccepted:function (){
            return this.showDocumentFields() && (this.operation !== undefined && this.operation.payment_source.department_id !== this.document.department_id) && this.document.department_not_accepted == 1;
        },
        handleSourceTransferAmountChange: function () {
            if (!isNaN(this.source_transfer_amount)) {
                this.source_transfer_amount = this.money.localize(this.money.toFloat(this.source_transfer_amount))
            } else {
                this.source_transfer_amount = this.money.localize(this.money.toFloat('0'))
            }
        },
        uncheckDocumentTransfer: function () {
            this.documentTransfer = false;
        },
        isDisabled: function (type) {
            return this.operation.id > 0 && this.connection_type !== type;
        }
    }

}
</script>

<style scoped>

</style>
